import './style.scss'

import Title from 'components/Title'
import RichText from 'components/RichText'
import Modal from 'components/Modal'

export default {
  name: 'VideoGrid',
  props: ['componentData'],
  methods: {
    handleImageClick (e) {
      this.$store.dispatch('openModal', { id: e.target.id })
    }
  },
  render (h) {
    const { componentData, handleImageClick } = this
    return (
      <div class='VideoGrid'>
        {componentData.map((i, index) => (
          <div class='VideoGrid__item'>
            <div class='VideoGrid__image'
              id={`modal-${index}`}
              role='button'
              onClick={handleImageClick.bind(this)}
              style={`background-image: url('${i.poster_image.sizes.friwi_med}')`}
            >
              <div class='VideoGrid__playbutton'>
                <div class='VideoGrid__playbutton-inner' />
              </div>
            </div>
            <img class='VideoGrid__printImage' src={i.poster_image.sizes.friwi_med} />
            <Title class='VideoGrid__title' level={3} id={i.title}>{i.title}</Title>
            <RichText class='VideoGrid__text' content={i.text} />
            <Modal id={`modal-${index}`}>
              <div class='Modal__embed-container'>
                <div class='Modal__embed' domPropsInnerHTML={i.oembed} />
              </div>
            </Modal>
          </div>

        ))}
      </div>
    )
  }
}

// <div>{i.title}, {i.text}, {i.oembed}, {i.poster_image.sizes.friwi_med}</div>



// WEBPACK FOOTER //
// ./client/components/VideoGrid/index.js